<template>
    <section class="slice barometer-home__info">
        <div class="slice-content">
            <h2 class="slice-title" v-html="t('barometer.informations.title.2', [generalBarometer.country])" />
            <div class="slice-body barometer-home__info__columns">
                <div class="joy-mb-8">
                    <figure class="barometer-home__info__figure">{{ formatNumber(generalBarometer.nbFreelancers) }}</figure>
                    <div v-html="t('barometer.informations.freelancers.count.title')" />
                </div>
                <div class="joy-mb-8">
                    <figure class="barometer-home__info__figure">{{ formatNumber(generalBarometer.nbSearchLastMonth) }}</figure>
                    <div v-html="t('barometer.informations.search.count.title')" />
                </div>
                <div class="joy-mb-8">
                    <figure class="barometer-home__info__figure">{{ generalBarometer.averageRating.toFixed(1) }} / 5</figure>
                    <div v-html="t('barometer.informations.average.rate.title')" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {BAROMETER_HOME} from '~/keys';

    const {t} = useTranslation();
    const {generalBarometer} = inject(BAROMETER_HOME)!;

    function formatNumber(num: number) {
        const thousandsSeparator = ' ';
        const decimalSeparator = ',';
        const pattern = /(\d+)(\d{3})/g;
        const [wholePart, decimalPart] = num.toString().split('.');
        return wholePart.replace(pattern, `$1${thousandsSeparator}$2`);
    }
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .barometer-home__info {
        &__columns {
            @include mq.screen_sm(min) {
                display: inline-flex;
                gap: var(--joy-core-spacing-8);
                > div {
                    min-width: 200px;
                    margin-bottom: 0 !important;
                }
            }

            figure {
                font-family: var(--joy-font-family-title);
                font-size: var(--joy-font-size-secondary-600);
                font-weight: var(--joy-font-weight-bold);
                color: var(--joy-color-primary-50);
                white-space: nowrap;
            }
        }
    }
</style>
